// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--rH2l4";
export var cards = "styles-module--cards--Y8FKu";
export var m_features = "styles-module--m_features--u2plv";